'use client'

// NOTE: you would use Button when you want to trigger some action on the same page.

import { cn } from '@/lib/utils'
import { PropsWithChildren } from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'dark' | 'outline'

type ButtonProps = {
  className?: string
  variant?: ButtonVariant
} & PropsWithChildren &
  React.ButtonHTMLAttributes<HTMLButtonElement>

const buttonClasses: Record<ButtonVariant, string> = {
  primary: 'bg-black hover:bg-white/20 active:bg-[#9E3BE9]',
  secondary: 'bg-[#9E3BE9] active:bg-[#9E3BE9]/50',
  dark: 'bg-black hover:bg-white/20',
  outline: 'bg-white/20',
}

export function Button({ variant = 'primary', className = '', children, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'rounded-full border border-white/30 p-2.5 text-base text-white transition-all duration-75 hover:border-white/50',
        buttonClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
